import { useState } from "react";
import { toast } from "sonner";
import { Printer, Loader2 } from "lucide-react";
import api from "@/lib/api";

export const PRINTABLE_CATEGORIES = ["quiz", "comprendre", "puzzle", "pronunciation"];
export const PRINTABLE_BUILTINS = ["sudoku_facile", "sudoku_moyen", "crossword", "picwords", "pathtrace", "differences"];

export default function PrintGameButton({ game }) {
  const [busy, setBusy] = useState(false);
  const ok = game?.builtin ? PRINTABLE_BUILTINS.includes(game.id) : game?.printable && PRINTABLE_CATEGORIES.includes(game.category);
  if (!ok) return null;
  const print = async () => {
    setBusy(true);
    try {
      const r = await api.get(game.builtin ? `/builtin-games/${game.id}/print/pdf` : `/games/${game.id}/print/pdf`, { responseType: "blob" });
      const href = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = href; a.download = `${game.title}.pdf`; a.click();
      setTimeout(() => URL.revokeObjectURL(href), 2000);
      toast.success(game.category === "pronunciation" ? "La fiche à imprimer est prête, avec la liste des mots à la fin." : game.id === "pathtrace" ? "La fiche à imprimer est prête." : "La fiche à imprimer est prête, avec le corrigé à la fin.");
    } catch { toast.error("La fiche n'a pas pu être créée."); }
    finally { setBusy(false); }
  };
  return (
    <button onClick={print} disabled={busy} data-testid={`print-game-${game.id}`}
      className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-white border-2 border-emerald-200 text-emerald-800 font-patient font-bold hover:bg-emerald-50 transition-colors disabled:opacity-60">
      {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Printer className="w-5 h-5" />} Imprimer ce jeu
    </button>
  );
}
